import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  @Input() expanded: boolean;
  @Output() selectedNavItem = new EventEmitter<Object>();

  selected;
  selectedSection;
  menuItems = [];

  constructor(private router: Router) {
    // this routine analyzes the URL to determine which sidenav item to highlight
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let urlParts = event.url.split('/');
        if (urlParts[2]) {
          if (urlParts[1] === 'incidents') {
            this.selected = 'incidents/new';
          }
          if (urlParts[1] === 'jumpers') {
            this.selected = 'jumpers';
            if (urlParts[2] === 'transfer') {
              this.selected = 'jumpers/transfer';
            }
            if (urlParts[2] === 'ldo') {
              this.selected = 'jumpers/ldo';
            }
          }
          if (urlParts[1] === 'mars') {
            if (urlParts[2] === 'search'){
              this.selected = 'mars/search';
            }
            if (urlParts[2] === 'mars-incident'){
              this.selected = 'mars/mars-incident';
            }
            if (urlParts[2] === 'gallery'){
              this.selected = 'mars/gallery';
            }
          }
        } else {
          this.selected = urlParts[1];
        }
      }
    });
  }

  ngOnInit(): void {
    this.getMenuItems();
  }

  getMenuItems = () => {
    let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));

    // this should be refactored to use async code instead of a setTimeout()
    if (!userInfo) {
      setTimeout(() => {
        this.getMenuItems();
      }, 100);
    } else {
      let role = userInfo.role;
      if (role === 'baseadmin' || role === 'sysadmin' || role === 'user') {
        this.menuItems = [       
          {
            name: 'Main Menu',
            bgcolor: '#565656',
            color: '#FFFFFF',
            border: '#000000',
            font: '32px',
            cursor: 'auto'
          },
          {
            name: 'Dashboard',
            route: 'dashboard',
            color: '#565656',
            border: '#565656'
          },
          {
            name: 'Master Action',
            color: '#565656',
            border: '#E58212',
            items: [            
              {
                name: 'Incidents',
                route: 'incidents'
              },
              {
                name: 'Reports',
                route: 'reports'
              }
            ]
          },
          {
            name: 'MARS',
            color: '#565656',
            border: '#2C75C9',
            items: [          
              {
                name: 'Incidents',
                route: 'mars/search'
              },
              {
                name: 'Reports',
                route: 'mars/reports'
              }
            ]
          }
        ]
      };
      if (role === 'baseadmin' || role === 'sysadmin') {
        this.menuItems.push({
          name: 'Base Admin',
          color: '#565656',
          border: '#325681',
          items: [
            {
              name: 'Pilots',
              route: 'pilots'
            },
            {
              name: 'Aircrafts',
              route: 'aircraft'
            },
            {
              name: 'Jumpers',
              route: 'jumpers'
            },
            {
              name: 'Transfer Jumper',
              route: 'jumpers/transfer'
            },
            {
              name: 'Edit LDO',
              route: 'jumpers/ldo'
            },
            {
              name: 'Loft',
              route: 'chutes'
            },
            {
              name: 'Spike Bases',
              route: 'bases'
            }
          ]
        })
      };

      if (role === 'sysadmin') {
        this.menuItems.push({
          name: 'System Admin',
          color: '#565656',
          border: '#336600',
          items: [
            {
              name: 'Manage Users',
              route: 'users',
              color: '#000000'
            },
            {
              name: 'Qualifications',
              route: 'qualifications'
            },
            {
              name: 'Pre-2004 Jumps',
              route: 'pre2004jumps'
            }
          ]
        })

        if (userInfo.isMarsAdmin) {
          let menuIndex = this.menuItems.findIndex(i => i.name == 'System Admin');
          if (menuIndex) {
            this.menuItems[menuIndex].items.push({
              name: 'Diagnostics',
              route: 'diagnostic'
            })
          }
        }


      };
    };
  };

  // handle sidenav menu item gets clicked.
  // either show the item's submenu if it has one,
  // or go to the item's associated route
  select = (item) => {
    this.selected = item.route
     if (item.items) {
      item.expanded = !item.expanded;
      this.selectedSection = item;
    }  else {
      if (item.route) {
        this.selected = item.route;
        this.selectedSection = this.menuItems.find(section => section.items && section.items.includes(item));
        // re-init table page settings when navigating via side menu
        let year = new Date().getFullYear();
        let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
        let base = userInfo.baseCode;
        window.sessionStorage.setItem('chutesType', 'All');
        window.sessionStorage.setItem('jumpersType', 'current');
        window.sessionStorage.setItem('incidentsBase', base);
        window.sessionStorage.setItem('incidentsYear', year.toString());
        window.sessionStorage.setItem('page', '0');
        window.sessionStorage.setItem('rows', '25');
        window.sessionStorage.removeItem('sortHistory');
        if (item.params) {
          this.router.navigate([item.route, item.params]);
        } else {
          this.router.navigate([item.route]);
        }
        this.selectedNavItem.emit(item);
      }
    }
  };

}
